import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { ReviewerState } from '../interfaces/interface';
import { createReview, getCommonIdentifiers, getReview, getReviewCustomPushbackStage, getReviewToReview, updateReview } from '../slices/reviewerSlice';

const ExtraReducers = (builder: ActionReducerMapBuilder<ReviewerState>) => {
    builder
        .addCase(createReview.pending, (state) => {
            state.createReviewStatus = STATUS.PENDING;
        })
        .addCase(createReview.fulfilled, (state, action) => {
            state.createReviewStatus = STATUS.SUCESS;
            console.log({aBC: action.payload})
            state.reviewer = action.payload;
            state.createReviewMessage = action.payload?.message
        })
        .addCase(createReview.rejected, (state, action: any) => {
            state.createReviewStatus = STATUS.FAILED;
         
            state.createReviewMessage = action.payload?.message || "An error occrred"
        })
        .addCase(getReview.pending, (state) => {
            state.getReviewStatus = STATUS.PENDING;
        })
        .addCase(getReview.fulfilled, (state, action) => {
            state.getReviewStatus = STATUS.SUCESS;
            state.reviewer = action.payload;

        })
        .addCase(getReview.rejected, (state, action: any) => {
            state.getReviewStatus = STATUS.FAILED;
            state.getReviewMessage = action.payload?.message || "An error occrred"
        })
        .addCase(getReviewCustomPushbackStage.pending, (state) => {
            state.getReviewCustomPushbackStageStatus = STATUS.PENDING;
        })
        .addCase(getReviewCustomPushbackStage.fulfilled, (state, action) => {
            state.getReviewCustomPushbackStageStatus = STATUS.SUCESS;
            state.customPushbackStage = action.payload;
        })
        .addCase(getReviewCustomPushbackStage.rejected, (state, action: any) => {
            state.getReviewCustomPushbackStageStatus = STATUS.FAILED;
        })
        .addCase(getReviewToReview.pending, (state) => {
            state.getReviewToReviewStatus = STATUS.PENDING;
        })
        .addCase(getReviewToReview.fulfilled, (state, action) => {
            state.getReviewToReviewStatus = STATUS.SUCESS;
            state.configsReview = action.payload;

        })
        .addCase(getReviewToReview.rejected, (state, action: any) => {
            state.getReviewToReviewStatus = STATUS.FAILED;
        })
        .addCase(updateReview.pending, (state) => {
            state.updateReviewStatus = STATUS.PENDING;
        })
        .addCase(updateReview.fulfilled, (state, action) => {
            state.updateReviewStatus = STATUS.SUCESS;
            state.reviewer = action.payload;
            state.updateReviewMessage = action.payload?.data?.message
        })
        .addCase(updateReview.rejected, (state, action: any) => {
            state.updateReviewStatus = STATUS.FAILED;
            state.updateReviewMessage = action.payload?.message || "An error occrred"
        })

        .addCase(getCommonIdentifiers.pending, (state) => {
            state.getCommonIdentifiersStatus = STATUS.PENDING;
        })
        .addCase(getCommonIdentifiers.fulfilled, (state, action) => {
            state.getCommonIdentifiersStatus = STATUS.SUCESS;
            state.commonIdentifiers = action.payload;
        })
        .addCase(getCommonIdentifiers.rejected, (state, action: any) => {
            state.getCommonIdentifiersStatus = STATUS.FAILED;
        })
};

export default ExtraReducers;
